 <div class="row light-bg">

     <div class="col-sm-12">
         <div class="m-content">
             <div class="row">
                 <div class="col-sm-12" style="padding-bottom: 5px;">
                     <div class="">
                         <div class="pt-0 pb-0" style="padding:0;">
                             <div class="login-block" style="min-height: 273px;">
                                 <div class="m-portlet__body">
                                     <div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right" >{{'NAME' | dictionary}}</div>
                                             <input type="textbox" [(ngModel)]="userProfileEntity.Username"
                                                 class="form-control home-login-input-text col-sm-6"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right">{{'CURRENT_ADDRESS' | dictionary}}
                                             </div>
                                             <input type="text" [(ngModel)]="userProfileEntity.CurrAddressLine1"
                                                 class="form-control home-login-input-text col-sm-6"
                                                 aria-describedby="emailHelp" />

                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'FROM' | dictionary}}</div>
                                             <MaskedTextBox #txtCurrAddrEffectiveFrom
                                                 CharacterCasing="Upper" MaxLength="4" DisplayMode="Mask"
                                                 InputMask="00/00" width="48px" TabIndexVal="0">
                                             </MaskedTextBox>
                                           {{'TO' | dictionary}}
                                             <MaskedTextBox #txtCurrAddrEffectiveTo
                                                 CharacterCasing="Upper" MaxLength="4" DisplayMode="Mask"
                                                 InputMask="00/00" width="48px" TabIndexVal="0">
                                             </MaskedTextBox>
                                         </div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right" ></div>
                                             <input type="text" [(ngModel)]="userProfileEntity.CurrAddressLine2"
                                                 class="form-control home-login-input-text col-sm-6"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper" >
                                             <div class="col-sm-2 text-right">{{'CITY' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.City"
                                                 class="form-control home-login-input-text col-sm-2"
                                                 aria-describedby="emailHelp" />
                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'STATE' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.State"
                                                 class="form-control home-login-input-text col-sm-1"
                                                 aria-describedby="emailHelp" />
                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'ZIP' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.Zip"
                                                 class="form-control home-login-input-text col-sm-1"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right" >{{'PHONE' | dictionary}}</div>
                                             <input type="textbox" [(ngModel)]="userProfileEntity.Phone"
                                                 class="form-control home-login-input-text col-sm-5"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <hr style="background-color: #000;" />

                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right">{{'LEGAL_ADDRESS' | dictionary}}
                                             </div>
                                             <input type="text" [(ngModel)]="userProfileEntity.LegalAddressLine1"
                                                 class="form-control home-login-input-text col-sm-6"
                                                 aria-describedby="emailHelp" />

                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'FROM' | dictionary}}</div>
                                             <MaskedTextBox #txtLegalAddrEffectiveFrom
                                                 CharacterCasing="Upper" MaxLength="4" DisplayMode="Mask"
                                                 InputMask="00/00" width="48px" TabIndexVal="0">
                                             </MaskedTextBox>
                                           {{'TO' | dictionary}}
                                             <MaskedTextBox #txtLegalAddrEffectiveTo
                                                 CharacterCasing="Upper" MaxLength="4" DisplayMode="Mask"
                                                 InputMask="00/00" width="48px" TabIndexVal="0">
                                             </MaskedTextBox>
                                         </div>
                                         <div class="field-wrapper" >
                                             <div class="col-sm-2 text-right" ></div>
                                             <input type="text" [(ngModel)]="userProfileEntity.LegalAddressLine2"
                                                 class="form-control home-login-input-text col-sm-6"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper" >
                                             <div class="col-sm-2 text-right">{{'CITY' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.LegalCity"
                                                 class="form-control home-login-input-text col-sm-2"
                                                 aria-describedby="emailHelp" />
                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'STATE' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.LegalState"
                                                 class="form-control home-login-input-text col-sm-1"
                                                 aria-describedby="emailHelp" />
                                             <div class="col-sm-1 text-right" style="padding-top: 5px;">{{'ZIP' | dictionary}}</div>
                                             <input type="text" [(ngModel)]="userProfileEntity.LegalZip"
                                                 class="form-control home-login-input-text col-sm-1"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right" >{{'PHONE' | dictionary}}</div>
                                             <input type="textbox" [(ngModel)]="userProfileEntity.LegalPhone"
                                                 class="form-control home-login-input-text col-sm-5"
                                                 aria-describedby="emailHelp" />
                                         </div>
                                         <div class="field-wrapper">
                                             <div class="col-sm-2 text-right" >
                                               {{'SPECIAL_INSTRUCTIONS' | dictionary}}
                                             </div>
                                             <textarea class="form-control home-login-input-text col-sm-6" [(ngModel)]="userProfileEntity.SpecialInstruction"
                                                 style="height: 135px;margin-bottom: 10px;"></textarea>
                                         </div>
                                     </div>


                                     <div class="col-sm-12">
                                         <div class="form-group text-center">
                                             <button (click)="submit()"
                                                 class=" button-1 text-color-1">
                                               {{'SUBMIT' | dictionary}}
                                             </button>
                                             <button (click)="cancel()"
                                                 class="ml-15  button-1 text-color-1">
                                                 {{'CANCEL' | dictionary}}
                                             </button>
                                             <div class="col-sm-12" style="height: 5px;"></div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
     </div>

     <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
     </app-pop-up-dialog>

 </div>
